import Game from './Game';
export default Game;


// WEBPACK FOOTER //
// ./src/containers/Game/index.js